// import moment from 'moment';
import CONSTANTS from 'utils/constants';
import * as yup from 'yup';
import { getFormatMessage, getDateMessage } from 'utils/schema';

const defaultShape = {
  email: yup.string().email().required(),
  name: yup.string(),
  phoneNumber: yup.string(),
  role: yup.number(),
  status: yup.string(),
  createdAt: yup.string(),
  updatedAt: yup.string(),
};
const yupSchema = yup.object().shape(defaultShape);

const yupCreateSchema = yup.object().shape({
  ...defaultShape,
  password: yup
    .string()
    .min(6, 'The password must contain at least 6 caracters.'),
});

export const infosSchemaBlock = [
  {
    key: 'email',
    label: getFormatMessage,

    _form: {
      label: getFormatMessage,

      id: 'email',
      required: true, // for yup
      name: 'email',
      type: 'email',
    },
  },
  {
    key: 'password',

    _createForm: {
      label: getFormatMessage,
      id: 'password',
      name: 'password',
      type: 'password',
      placeholder: 'At least 6 caracters.',
    },
  },
  {
    key: 'name',
    label: getFormatMessage,

    _form: {
      label: getFormatMessage,

      id: 'name',
      name: 'name',
      type: 'text',
    },
  },
  {
    key: 'firstName',
    label: getFormatMessage,

    _form: {
      label: getFormatMessage,

      id: 'firstName',
      name: 'firstName',
      type: 'text',
    },
  },
  {
    key: 'lastName',
    label: getFormatMessage,

    _form: {
      label: getFormatMessage,

      id: 'lastName',
      name: 'lastName',
      type: 'text',
    },
  },
  {
    key: 'phoneNumber',
    label: getFormatMessage,

    _form: {
      label: getFormatMessage,

      id: 'phoneNumber',
      name: 'phoneNumber',
      type: 'text',
    },
  },
  {
    key: 'createdAt',
    label: getFormatMessage,
    content: getDateMessage,
  },
  {
    key: 'status',
    label: getFormatMessage,
  },

  {
    key: 'role',
    label: getFormatMessage,
    content: (_entity, key) => {
      const role = _entity[key];
      if (role) {
        return CONSTANTS.USERS_ROLES_AS_STRING[role];
      }
      return '';
    },
    _form: {
      label: getFormatMessage,

      id: 'role',
      name: 'role',
      type: 'select',
      /**
       *
       * @param {*} _entity
       * @param {*} key
       * @param {*} options
       * { (value, label)}
       */
      inputs: (_entity, key, options) => {
        const keyOptions = options[key];
        return keyOptions || [];
      },
    },
  },
];

export default {
  yupSchema,
  yupCreateSchema,
  blocks: [infosSchemaBlock],
};
